import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Pricing } from "@/components/Pricing";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { OrderModal } from "@/components/OrderModal";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Pricing />
      <Contact />
      <Footer />
      <OrderModal />
    </main>
  );
}
